#import "./AssetCheckFields.graphql"

fragment AssetFields on Asset {
  id
  fphNumber
  category
  productType
  productName
  manufacturer
  modelNumber
  serialNumber
  deviceName
  operatingSystem
  ramGb
  entity
  status
  condition
  location
  purchasedOn
  purchasePrice {
    minorUnit
    currency
  }
  orderReference
  supplier
  purchasedBy {
    id
    name
  }
  productUrl
  warrantyType
  warrantyExpiresOn
  financeAssetRef
  mobileNumber
  networkProvider
  disposedOn
  disposalMethod
  notes
  salesforceId
  createdAt
  currentAssignment {
    id
    holderName
    location
    assignedOn
    employee {
      id
      name
    }
  }
  assignments {
    id
    holderName
    location
    assignedOn
    returnedOn
    returnMethod
    returnCondition
    assignedByName
    returnedByName
    notes
  }
  latestChecks {
    ...AssetCheckFields
  }
  checks {
    ...AssetCheckFields
  }
  documents {
    id
    kind
    originalFilename
    url
    uploadedByName
    createdAt
  }
  secrets {
    id
    kind
    createdAt
    createdByName
    replacedAt
    reveals {
      id
      revealedByName
      reason
      createdAt
    }
  }
}
